const replaceBodyHTML = async (targetDocument, newXHTML) => {
  const htmlElement = targetDocument.documentElement;
  const bodyElement = targetDocument.body;

  if (!htmlElement.getAttribute('xmlns')) {
    htmlElement.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
  }

  if (!htmlElement.getAttribute('xmlns:epub')) {
    htmlElement.setAttribute('xmlns:epub', 'http://www.idpf.org/2007/ops');
  }

  // Preempt the browser from mis-interpreting self-closing tags and using them to scramble the html source.
  let arrayOfXHTMLSplitByEndTags = newXHTML.split('/>');
  let newXHTMLWithTagsClosed = '';
  for (let i = 0; i < arrayOfXHTMLSplitByEndTags.length - 1; i++) {
    let arrayOfXHTMLSplitByStartTags = arrayOfXHTMLSplitByEndTags[i].split('<');
    newXHTMLWithTagsClosed += `${arrayOfXHTMLSplitByEndTags[i]}></${
      arrayOfXHTMLSplitByStartTags[
        arrayOfXHTMLSplitByStartTags.length - 1
      ].split(' ')[0]
    }>`;
  }
  newXHTMLWithTagsClosed =
    newXHTMLWithTagsClosed +
    arrayOfXHTMLSplitByEndTags[arrayOfXHTMLSplitByEndTags.length - 1];

  try {
    // If valid xhtml, it can be appended directly to the body.
    // If we use appendChild to attach the created DocumentFragment to the html body, Chrome gives the content DOM functionality (like resolving images).
    // However Firefox does not. So we use createContextualFragment only to validate the xhtml, and innerHTML to attach it.
    bodyElement.ownerDocument
      .createRange()
      .createContextualFragment(newXHTMLWithTagsClosed);
    bodyElement.innerHTML = newXHTMLWithTagsClosed;
  } catch (error) {
    // If invalid xhtml, append to an html document element and
    // let the dom make a best guess on html format.

    // When setting xhtml to innerHTML, the context is outside
    // the current DOM. Therefore, need to wrap the content in
    // a div that defines the epub namespace for this new context.
    // Otherwise a xml parsing error is thrown. Additionally,
    // the wrapper will take care of any html entities that would
    // normally also throw a xml parsing error. The wrapper will
    // be removed after the iframe body innerHTML is set to not
    // interfere with CFI counts.
    // See https://stackoverflow.com/a/15916431/4064103.
    const epubNamespaceWrapper = document.createElement('div');
    epubNamespaceWrapper.setAttribute('id', 'epub-namespace-wrapper');
    epubNamespaceWrapper.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    epubNamespaceWrapper.setAttribute(
      'xmlns:epub',
      'http://www.idpf.org/2007/ops',
    );
    epubNamespaceWrapper.innerHTML = newXHTMLWithTagsClosed;

    bodyElement.innerHTML = null;
    bodyElement.appendChild(epubNamespaceWrapper);

    // As last step, need to remove epub-namespace-wrapper
    // as it throws off CFI count.
    for (let childElement of Array.from(epubNamespaceWrapper.childNodes)) {
      epubNamespaceWrapper.parentElement.appendChild(childElement);
    }
    epubNamespaceWrapper.parentElement.removeChild(epubNamespaceWrapper);
  }
};

export default replaceBodyHTML;
